import React from "react";
import Modal from "./Modal";
import Button from "./Button";
import { Trash2 } from "lucide-react";

const ConfirmDialog = ({
  isOpen,
  onClose,
  title = "Confirm Delete",
  description,
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  onConfirm,
  loading = false,
  destructive = true,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm">
      <div className="flex flex-col items-center text-center gap-4">
        <div className="h-16 w-16 rounded-full bg-red-50 dark:bg-red-900/30 flex items-center justify-center">
          <Trash2 className="h-8 w-8 text-red-600" />
        </div>

        <div className="text-sm text-gray-700 dark:text-gray-200">
          {description ||
            "This action cannot be undone. Are you sure you want to continue?"}
        </div>

        <div className="w-full flex justify-end gap-2">
          <Button
            variant="outline"
            onClick={onClose}
            size="sm"
            disabled={loading}
          >
            {cancelLabel}
          </Button>
          <Button
            variant={destructive ? "danger" : "primary"}
            onClick={onConfirm}
            size="sm"
            loading={loading}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDialog;
